module.exports = __webpack_public_path__ + "media/images/countryrect/wales-df54b8cd301cafc673a088f222b06947.svg";